import React from 'react'
import { connect } from 'react-redux'
import ModuleWithLoader from '../components/ModuleWithLoader'
import Heading from '../components/Heading'
import PaymentMethodContainer from '../forms/PaymentMethodContainer'
import InputRowPaymentMethod from '../components/InputRowPaymentMethod'

class PaymentInformation extends React.Component {
    constructor (props) {
        super(props)

        this.state = {
            showForm: false
        }
    }

    handleClick (event) {
        event.preventDefault()

        this.setState({
            showForm: !this.state.showForm
        })
    }

    render () {
        return (
            <div className='payment-information module overflow-visible'>
                <Heading title='Payment information' color='bg-indigo' />
                <ModuleWithLoader isLoaded className='p-4'>
                    <div className='row'>
                        <div className='col-12 col-md-8 offset-md-2'>
                            <div className='text-center text-md-left'>
                                <p className='mb-4 mt-0'>Your purchase will be charged to the payment method you have nominated for this account. You can elect to change your saved payment method below:</p>
                            </div>
                            <InputRowPaymentMethod displayPaymentVia={this.props.displayPaymentVia} />
                            <div className='mt-3 d-flex align-items-center flex-column flex-md-row text-center text-md-left'>
                                <div className='mr-md-4 flex-shrink-0'>
                                    <a href='#' onClick={this.handleClick.bind(this)} className={`btn btn-custom color-indigo ${this.props.className}`}>Change Payment Method</a>
                                </div>
                                <div>
                                    <p><small>Payments made by debit or credit card incur up to 1.0% transaction fee, please refer to terms and conditions of your service. You can avoid this fee by electing to pay via Direct Debit. This option is available in your MyExetel portal after order confirmation, under Payment and Invoices.</small></p>
                                </div>
                            </div>
                        </div>
                    </div>
                    {this.state.showForm
                        ? <div className='row'>
                            <div className='col-12 col-md-8 offset-md-2'>
                                <PaymentMethodContainer />
                            </div>
                        </div>
                        : ''}
                </ModuleWithLoader>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    paymentVia: state.auth.paymentVia
})

export default connect(mapStateToProps, {})(PaymentInformation)



// WEBPACK FOOTER //
// ./resources/js/modules/PaymentInformation.js